import React from 'react';
import { BuildPath } from  '@/helpers/Paths';
import { Direction } from  '@/interfaces/insightsp2';

const OrderIcon = ({order}:{order:Direction}): JSX.Element => {

    if (order === null){
        return <img data-testid="order-icon" src={`${BuildPath()}/images/insightsp2/sortbyblank.svg`} alt=""/>
    }
    else if (order === Direction.asc){
        return <img data-testid="order-icon" src={`${BuildPath()}/images/insightsp2/sortby.svg`} className="ascending" alt="" />
    }
    else{
        return <img data-testid="order-icon" src={`${BuildPath()}/images/insightsp2/sortby.svg`} className="descending" alt="" />
    }
}

export default OrderIcon;